import { AppMode } from "@client/ImperativeState";
import { getActiveMembers, getEffectiveTrack } from "@engine/round/accessors";
import { NotesAndFeedbackVisibility } from "@engine/round/actions";
import { RoundAggregate, RoundMember } from "@engine/round/aggregate";
import orderBy from "lodash/orderBy";

export function getMembersWithNotes(
  round: RoundAggregate,
  evaluableId: string,
  currentUserId: string,
  mode: AppMode,
): Array<{
  member: RoundMember;
  canAccess: boolean;
}> {
  const members = getActiveMembers(round);
  const effectiveTrack = getEffectiveTrack(mode, round.members[currentUserId]);

  const membersWithNotes = members.filter((member) => {
    if (member.id === currentUserId) {
      return true;
    }

    if (!(evaluableId in member.evaluableNotes)) {
      return false;
    }

    return true;
  });
  const membersWithCanAccess = membersWithNotes.map((member) => {
    // The current user can see if they're not in a different track.
    if (effectiveTrack === member.track || effectiveTrack === "NO_TRACK") {
      return {
        member,
        canAccess: true,
      };
    }

    const specificEvaluablePermission: NotesAndFeedbackVisibility =
      round.members[member.id].evaluablePermissions[evaluableId] ?? "default";

    if (specificEvaluablePermission === "hidden") {
      return {
        member,
        canAccess: false,
      };
    } else if (specificEvaluablePermission === "visible") {
      return {
        member,
        canAccess: true,
      };
    }

    return {
      member,
      canAccess: round.members[member.id].feedbackVisibleByDefault,
    };
  });

  const resultsSortedByInitials = membersWithCanAccess.sort((a, b) =>
    a.member.initials.localeCompare(b.member.initials),
  );

  const resultsWithSelfFirst = orderBy(
    resultsSortedByInitials,
    (m) => m.member.id !== currentUserId,
  );

  return resultsWithSelfFirst;
}
